import { Component } from '@angular/core';
import { NavController, AlertController, LoadingController, Loading, NavParams } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ecomUserApi } from '../../../api/ecom/ecomUserApi';
import { RegisterPage, AuthorisedHomePage } from '../../../pages/pages';
import { LoginModel } from '../../../api/swagger/ecomApi';
import {ApiConfig} from '../../../shared/api-config.service'
import {AppConfig} from '../../../shared/app-config.service'
import {LoggerService} from '../../../shared/logger.service'
import {GlobalErrorService} from '../../../shared/global-error.service'
import { Storage } from '@ionic/storage';
import { HomePage } from '../../home/home';
import { InAppBrowser } from '@ionic-native/in-app-browser';

@Component({
    selector: 'page-login',
    templateUrl: 'login.html',
    providers: [ecomUserApi, ApiConfig, LoggerService,AppConfig, GlobalErrorService]
  })

  export class LoginPage  {
    loginForm: FormGroup;
    loading: Loading;
    submitAttempt: boolean = false;
    showFailed: boolean = false;
    showMessage: boolean = false;
    showLogout: boolean = false;

    constructor(
      public navParams: NavParams,
      private navCtrl: NavController, 
      private ecomUserApi: ecomUserApi, 
      private formBuilder: FormBuilder, 
      private errorCtrl: GlobalErrorService,
      private alertCtrl: AlertController,
      private log: LoggerService,
      private loadingCtrl: LoadingController,
      public storage: Storage,
      private iab: InAppBrowser
    )        
    {
      this.showMessage = this.navParams.data;

      this.loginForm = formBuilder.group({
        email: ['', Validators.required],
        password: ['', Validators.compose([Validators.required])],
    });

    }
  
    ionViewDidLoad() {
      if(this.showMessage == true){
        this.errorCtrl.presentToast("Your registration was successful, please login using the details you just created.");
      }
    }

    goToRegister(){
      this.navCtrl.push(RegisterPage);
    }

    public showLoading() {
        this.loading = this.loadingCtrl.create();
        this.loading.present();        
    }

    ForgottenPassword(){
      this.iab.create("https://enetbadges.com/Account/ForgotPassword", "_system");
    }

    public loginToApp(){
      let loader = this.loadingCtrl.create();
          loader.present().then(()=>{
            var loginModel = new LoginModel({
              userName: this.loginForm.value.email,
              password: this.loginForm.value.password
            });
            this.ecomUserApi.Login(loginModel).subscribe(
              loginResult => {
                this.ecomUserApi.saveLoginToken(loginResult);
                if(loginResult.token != null){
                  this.showLogout = true;
                  this.navCtrl.setRoot(AuthorisedHomePage);
                  this.navCtrl.push(AuthorisedHomePage);
                  loader.dismiss();
                }
                else{
                  this.errorCtrl.presentToast("Sorry, there was an error logging in. Please check your details and try again.");
                  loader.dismiss();
                  this.logout();
                }
            },
            error => {
              this.errorCtrl.presentToast("Sorry, there was an error logging in. Please check your details and try again.");
              this.log.error(error);              
              loader.dismiss();
            }
          )
          });
    }

    logout() {
      let loader = this.loadingCtrl.create();
      loader.present().then(() => {
        this.storage.remove('username');
        this.storage.remove('accessToken');
        this.navCtrl.setRoot(HomePage);
        loader.dismiss().catch(err => console.log(err));
      }).catch(
        function (error) {
          loader.dismiss().catch(err => console.log(err))
        });
    }

    loginSave(){
        this.submitAttempt = true;
        if(this.loginForm.valid){
            this.loginToApp();
        }
    }

  }


// WEBPACK FOOTER //
// ./src/pages/authorization/login/login.ts